import React, { isValidElement, useContext } from 'react';
import { EngineContext } from '@philips-internal/oswald-ui-engine';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { useGlobalActionsStack } from '../../context/global-actions-stack-context.js';
import { isHybridDevice, isPrimaryInputTouch } from '../../utils/device-capabilities.js';
import './global-actions-stack-manager.css';
function GlobalActionsStackManager(props) {
    const { engine } = useContext(EngineContext);
    const stackContext = useGlobalActionsStack();
    const { actions = [], fragmentInstanceUUID } = stackContext.getActions() ?? {};
    const secondaryElement = stackContext.getSecondaryElement();
    if (actions.length <= 0 && !isValidElement(secondaryElement)) {
        return null;
    }
    const className = classNames({
        'c-global-actions-stack-manager': true,
        'c-global-actions-stack-manager--hide-on-desktop': props.hideOnDesktop ?? !isPrimaryInputTouch(),
        'c-global-actions-stack-manager--show-on-hybrid-mobile': isHybridDevice(),
    });
    const currentEngine = engine ?? props.engine;
    const fragmentUUID = fragmentInstanceUUID ?? '';
    const parentFragment = currentEngine?.getFragment(fragmentUUID);
    return (React.createElement(EngineContext.Provider, { value: { engine: currentEngine, root: parentFragment } },
        React.createElement("div", { className: className },
            isValidElement(secondaryElement) ? (React.createElement("div", { className: "c-global-actions-stack-manager__secondary-element" }, secondaryElement)) : null,
            actions.length > 0 ? (React.createElement("div", { className: "c-global-actions-stack-manager__actions" }, actions)) : null)));
}
export { GlobalActionsStackManager, };
export default GlobalActionsStackManager;
//# sourceMappingURL=global-actions-stack-manager.js.map